import style from './DefaultLayout.module.scss';
import className from 'classnames/bind';
import { Layout } from 'antd';
import Header from "../Header";
const { Content } = Layout;

const cn = className.bind(style);

function DefaultLayout({children})
{
	return (
		<div className={cn('wrapper')}>
			<div className={cn('wrapper-inner')}>
				<Layout>
					<Header></Header>
					<Content>
						<div className={cn('content')}>
							{children}
						</div>
					</Content>
				</Layout>
			</div>
		</div>
	);
}

export default DefaultLayout;